<svelte:options customElement="claims-history-main" />

<script>
    import { onMount } from "svelte";
    import { loadAssets, baseUrl } from "../../../../../SharedSvelte/Common.svelte";
    import { claimsHistoryState } from "../../state/ApplicationState.svelte";
    import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
    import GlobalLoader from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import ClaimsHistory from './ClaimsHistory.svelte';
    
    let apiPromise;

    async function fetchHistoryContent() {
        Loader.display();
        
        try {
            const response = await fetch(`${baseUrl}Options/Claims/HistoryOptions`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    '__RequestVerificationToken': document.getElementsByName("__RequestVerificationToken")[0].value
                }
            });

            window.scrollTo(0, 0);

            if (!response.ok) {
                const error = `Server exception: ${response.status} ${response.statusText}`;
                //prompt.showMessage(error, "Information");
                throw new Error(error);
            }

            const data = await response.json();
            claimsHistoryState.memberOptions = data.memberOptions;
            claimsHistoryState.claimTypeOptions = data.claimTypeOptions;
            claimsHistoryState.beginningDate = data.beginningDate.split("T")[0];
            claimsHistoryState.endingDate = data.endingDate.split("T")[0];

            if (data.memberOptions.length > 0) {
			    claimsHistoryState.memberId = data.memberOptions[0].key;
		    }

		    if (data.claimTypeOptions.length > 0) {
			    claimsHistoryState.claimType = data.claimTypeOptions[0].key;
		    }
            return data; // Resolves the Promise with the fetched data
        } catch (error) {
            console.error("Error fetching history options:", error);
            return Promise.reject(error); // Rejects the Promise with the error
        } finally {
            Loader.hide();
        }
    }

    onMount(async () => {
        setTimeout(() => {
            loadAssets("claims-history-main");
        }, 10);
        apiPromise = 
            fetchHistoryContent()
            .then(historyData => {
                // console.log("options loaded:", historyData);
            });
    });
</script>

{#await apiPromise}
    <div>Loading...</div>
{:then data}
    <!-- <pre>{JSON.stringify(data)}</pre> -->
    
    <ClaimsHistory />
    
<!-- {:catch error}
    <div class="text-danger">{error}</div> -->
{/await}

<GlobalLoader />


